module.exports = __webpack_public_path__ + "img/19.5f65992c.jpg";